/* eslint-disable prefer-destructuring */
/* eslint-disable prefer-template */
/* eslint-disable no-sequences */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-unused-expressions */
/* eslint-disable func-names */
/* eslint-disable no-useless-escape */
import React, { PureComponent } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import FullStory, { FullStoryAPI } from "react-fullstory";
import { initLocale } from "store/actions/localeActions";
import { loadPage, setPage } from "store/actions/pageActions";
import { loadMe, setMe } from "store/actions/userActions";
import { setError } from "store/actions/editorActions";
import { loadPages } from "store/actions/headerActions";
import Workbanch from "editor/containers/Workbanch";
import MainLoading from "editor/containers/MainLoading";
import ErrorBoundary from "editor/containers/ErrorBoundary";
import { FileTypes } from "shared/utils";
import { initialize as initializeCerberus } from "@alboom/alboom-cerberus";

const LoaderWrapper = styled.div`
  opacity: ${(props) => (props.loading ? 0 : 1)};
  transition: opacity 0.2s ease-in-out;
`;

class AppContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.events = {
      dragenter: this.handleDragEnter,
      dragover: this.captureDrop,
      dragleave: this.handleDragLeave,
      drop: this.captureDrop,
    };
    this.state = {
      loading: true,
      error: null,
    };
    this.dragTimeout = false;
    this.validTypes = ["Image"];
  }

  componentWillMount() {
    this.loadAlb();
  }

  componentDidMount() {
    const { pathname } = window.location;
    const { initLocale, loadPages, setPage, setError, setMe } = this.props;
    try {
      const { id } = /^(\/content\/pages)?\/(?<id>[^\/]+)/.exec(
        pathname
      ).groups;
      loadPages();
      loadMe()
        .then((response) => {
          const userData = response.data;
          this.startFullStory(userData);
          this.startAlb(userData);
          this.startCerberus(userData);
          setMe(userData);
          loadPage(id).then(({ data }) => {
            window.SaveManager.enable();
            setPage(data);
            const lang = userData.core_config.language;
            initLocale(lang, () => {
              this.setState({ loading: false });
              this.setupEvents();
            });
          });
        })
        .catch(this.handleUserRequestError);
    } catch (error) {
      setError(error);
    }
  }

  componentWillUnmount() {
    window.SaveManager.stopTimer();
    Object.keys(this.events).forEach((listener) => {
      window.removeEventListener(listener, this.events[listener], false);
    });

    window.DragManager.unsubscribe("dragleave", this.handleDragLeave);
    window.DragManager.unsubscribe("dragenter", this.handleDragEnter);
  }

  /**
   * This captures the event and prevents the default behavior
   * of the browser. Used to prevent files from being openned when
   * dropping them directly into the window.
   */
  captureDrop = (e) => {
    e.preventDefault();
  };

  handleDragEnter = (e) => {
    e.preventDefault();
    const { dragging } = this.props;
    if (this.dragTimeout) {
      clearTimeout(this.dragTimeout);
      this.dragTimeout = null;
    }
    if (dragging) {
      console.log("ainda no drag");
      window.DragManager.showOverlay();
    } else {
      // This means that the interval executed, so we must
      // start a new drag process.
      const {
        dataTransfer: { items, types },
      } = e;

      // if we're draggin an element, register the start drag
      // with the previous element in memory.
      if (types.includes("element")) {
        const { action, ...element } = window.DragManager.currentDragging;
        window.DragManager.registerStart(action, element);
      } else if (types.includes("Files")) {
        if (FileTypes.anyValid(this.validTypes, items)) {
          window.DragManager.registerStartFiles(items.length);
        }
      }
    }
  };

  /**
   * When something gets dragged outside the window, if it's
   * outside of the main window, clear the overlay.
   *
   * @param {DragEvent} e DragEvent of the dragleave type
   */
  handleDragLeave = (e) => {
    e.preventDefault();
    const { clientX, clientY } = e;
    if (
      (e.view === window && clientX === 0 && clientY === 0) ||
      (clientX < 0 && clientX === -230) ||
      (clientY < 0 && clientY > -50)
    ) {
      console.log("registrando interval para limpar drag");
      window.DragManager.clearOverlay();
      this.dragTimeout = setTimeout(() => {
        console.log("limpando clear");
        window.DragManager.clear();
        this.dragTimeout = null;
      }, 3000);
    }
  };

  /**
   * Handle errors that occurred during loading details from
   * the user logged.
   *
   * @memberof AppContainer
   */
  handleUserRequestError = (err) => {
    const { setError } = this.props;
    const fn = (err) => {
      setError(err);
    };
    if (err.response) {
      switch (err.response.status) {
        case 401: {
          console.log("[PROSITE] 401 error, redirecting to login page");

          const { protocol, host, pathname } = window.location;
          const redirPage = `${protocol}//${host}`;
          const baseUrl = `${window.ACCOUNTS_URL}/auth/accounts/login?srv=prosite&path=`;
          window.location.href = `${baseUrl}${pathname.slice(
            1
          )}&host=${redirPage}`;
          break;
        }
        default:
          fn(err);
      }
    } else {
      fn(err);
    }
  };

  /**
   * Loads the alb library into the application
   *
   * @memberof AppContainer
   */
  loadAlb = () => {
    (function (i, s, o, g, r, a, m) {
      (i[r] =
        i[r] ||
        function () {
          (i[r].q = i[r].q || []).push(arguments);
        }),
        (i[r].i = 1 * new Date());
      if (!s.getElementById("sdk-" + r)) {
        (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
        a.id = "sdk-" + r;
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
      }
    })(
      window,
      document,
      "script",
      "https://storage.alboompro.com/libs/alb/alb-1.1.3.js",
      "alb"
    );
  };

  /**
   * Setup events in the window and also configure subscribers
   * for drag n' drop events within the iframe.
   *
   * @memberof AppContainer
   */
  setupEvents = () => {
    Object.keys(this.events).forEach((listener) => {
      window.addEventListener(listener, this.events[listener], false);
    });

    window.DragManager.subscribe("dragleave", this.handleDragLeave);
    window.DragManager.subscribe("dragenter", this.handleDragEnter);
  };

  /**
   * Configures the alb library with current user information
   *
   * @param {Object} userData data received from auth process.
   */
  startAlb = (userData) => {
    window.alb(
      "cloud",
      "auth",
      userData.owner_id,
      "uYDJaxros48CaAhgX7zpA",
      window.USER_TOKEN,
      window.APP_CODE
    );

    window.alb(
      "aiCreateText",
      "auth",
      userData.owner_id,
      window.USER_TOKEN,
      window.APP_CODE
    );
  };

  /**
   * Starts tracking user interaction within the application
   * using fullStory.
   *
   * @param {Object} userData data received from auth process.
   */
  startFullStory = (userData) => {
    FullStoryAPI("identify", userData.owner_id, {
      displayName: userData.name,
      email: userData.email,
    });
  };

  startCerberus = (userData) => {
    const { initializeCerberus: initCerb } = this.props;
    const { resources } = userData.plan_info;

    initCerb("prosite", resources);
  };

  render() {
    const { locale } = this.props;
    const { loading, error } = this.state;
    return (
      <ErrorBoundary error={error}>
        <FullStory org="PJAAP" />
        <LoaderWrapper loading={!loading}>
          <MainLoading />
        </LoaderWrapper>
        <LoaderWrapper loading={loading}>
          <Workbanch key={`editor-locale-${locale}`} />
        </LoaderWrapper>
      </ErrorBoundary>
    );
  }
}

const mapDispatchToProps = {
  initializeCerberus,
  initLocale,
  loadPages,
  setError,
  setPage,
  setMe,
};

const mapStateToProps = (state) => ({
  locale: state.i18n.locale,
  dragging: state.editor.dragging,
});

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);
